import { SET_SCAMBER } from './../actionTypes';

export const setScamber = scamber => ({
    type: SET_SCAMBER,
    payload: {
        scamber
    }
})

